/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { SubGroup } from "../models/sub-group";
@Injectable({
  providedIn: "root",
})
class SubGroupsService extends __BaseService {
  static readonly subGroupsGetSubscriptionGroupsPath = "/api/SubGroups";
  static readonly subGroupsPostSubGroupPath = "/api/SubGroups";
  static readonly subGroupsDeleteSubGroupPath = "/api/SubGroups/{id}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param subscriptionId undefined
   */
  subGroupsGetSubscriptionGroupsResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<SubGroup>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/SubGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubGroup>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subGroupsGetSubscriptionGroups(
    subscriptionId?: number
  ): __Observable<Array<SubGroup>> {
    return this.subGroupsGetSubscriptionGroupsResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Array<SubGroup>)
    );
  }

  /**
   * @param params The `SubGroupsService.SubGroupsPostSubGroupParams` containing the following parameters:
   *
   * - `subGroup`:
   *
   * - `subscriptionId`:
   */
  subGroupsPostSubGroupResponse(
    params: SubGroupsService.SubGroupsPostSubGroupParams
  ): __Observable<__StrictHttpResponse<SubGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.subGroup;
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/SubGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubGroup>;
      })
    );
  }
  /**
   * @param params The `SubGroupsService.SubGroupsPostSubGroupParams` containing the following parameters:
   *
   * - `subGroup`:
   *
   * - `subscriptionId`:
   */
  subGroupsPostSubGroup(
    params: SubGroupsService.SubGroupsPostSubGroupParams
  ): __Observable<SubGroup> {
    return this.subGroupsPostSubGroupResponse(params).pipe(
      __map((_r) => _r.body as SubGroup)
    );
  }

  /**
   * @param id undefined
   */
  subGroupsDeleteSubGroupResponse(
    id: number
  ): __Observable<__StrictHttpResponse<SubGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/SubGroups/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubGroup>;
      })
    );
  }
  /**
   * @param id undefined
   */
  subGroupsDeleteSubGroup(id: number): __Observable<SubGroup> {
    return this.subGroupsDeleteSubGroupResponse(id).pipe(
      __map((_r) => _r.body as SubGroup)
    );
  }
}

module SubGroupsService {
  /**
   * Parameters for SubGroupsPostSubGroup
   */
  export interface SubGroupsPostSubGroupParams {
    subGroup: SubGroup;
    subscriptionId?: number;
  }
}

export { SubGroupsService };
